// extracted by mini-css-extract-plugin
export default {"outerMain":"footerFront_outerMain__ulQ+P","text":"footerFront_text__jRMey","subText":"footerFront_subText__hBt+G"};